export const viewingStatusLabel = (status) => ({new:'Pending',contacted:'Contacted',confirmed:'Confirmed',completed:'Completed',cancelled:'Cancelled',closed:'Closed'}[status] || status);

export function manilaParts(value) {
  if (!value) return {date:'',time:''};
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return {date:'',time:''};
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Manila',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(date).map(({type,value})=>[type,value]));
  return {date:`${parts.year}-${parts.month}-${parts.day}`,time:`${parts.hour}:${parts.minute}`};
}

export function calendarEvents(inquiries, applications) {
  return [
    ...inquiries.filter(item=>item.inquiry_type==='viewing').map(item=>({
      key:`guest-${item.id}`,source:'guest',id:item.id,name:item.name,property:item.apartment_name || 'Apartment',
      date:(item.status==='confirmed' || item.status==='completed' || item.status==='cancelled' || item.status==='closed') && item.confirmed_date ? item.confirmed_date : item.preferred_date,
      time:(item.status==='confirmed' || item.status==='completed' || item.status==='cancelled' || item.status==='closed') && item.confirmed_time ? item.confirmed_time : item.preferred_time,
      status:item.status,raw:item,
    })),
    ...applications.filter(item=>item.viewing_scheduled_at).map(item=>({
      key:`application-${item.id}`,source:'application',id:item.id,name:item.full_name,property:item.apartment_name,
      ...manilaParts(item.viewing_scheduled_at),status:['Rejected','Cancelled'].includes(item.application_status)?'cancelled':item.visited_at?'completed':'confirmed',raw:item,
    })),
  ].filter(item=>item.date).sort((a,b)=>`${a.date} ${a.time || ''}`.localeCompare(`${b.date} ${b.time || ''}`));
}

export function monthDays(month) {
  const [year,number]=month.split('-').map(Number);
  const count=new Date(Date.UTC(year,number,0)).getUTCDate();
  const offset=new Date(Date.UTC(year,number-1,1)).getUTCDay();
  return [...Array(offset).fill(null),...Array.from({length:count},(_,i)=>`${month}-${String(i+1).padStart(2,'0')}`)];
}

export function shiftMonth(month, amount) {
  const [year,number]=month.split('-').map(Number);
  return new Date(Date.UTC(year,number-1+amount,1)).toISOString().slice(0,7);
}
